<div class="panel panel-primary">
    @if (Loading) {
        <div class="loading"></div>
    }
    <div class="panel-heading">
        {{ PTPItemType === "0" ? "Request" : "Order" }} Audit
        <div class="pull-right">
            <button
                nz-button
                class="pf-form-action"
                [disabled]="PTPItem?.Transactions?.length + PTPItem?.PurchaseRequest?.Transactions?.length === 0"
                (click)="Refresh()">
                <span style="color: green" class="fa-solid fa-arrows-rotate"></span>Refresh
            </button>
        </div>
    </div>
    <div class="panel-body">
        <div class="panel panel-default">
            <div id="history" class="panel-heading">Transaction History</div>
            <div class="panel-body">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Time</th>
                            <th>Transaction</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (history of PTPItem?.Transactions; track history) {
                            <tr>
                                <td>
                                    {{ history.HistoryTime + "Z" | date: "MM/dd/yyyy h:mm:ss a" }}
                                </td>
                                <td>
                                    {{ history.Transaction }}
                                </td>
                            </tr>
                        }
                        @for (history of PTPItem?.PurchaseRequest?.Transactions; track history) {
                            <tr>
                                <td>
                                    {{ history.HistoryTime + "Z" | date: "MM/dd/yyyy h:mm:ss a" }}
                                </td>
                                <td>
                                    {{ history.Transaction }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
